module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h1', {
    staticClass: "basic-paragraph"
  }), _vm._v(" "), _c('p', {
    staticClass: "firstparagraph"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Notice to the Reader")])]), _vm._v(" "), _c('p', {
    staticClass: "basic-paragraph"
  }, [_vm._v("Foreign words and unfamiliar technical terms are explained briefly in the glossary in the back of the book.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-d6134b36","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/TheEyesOfVenice_00000.vue
// module id = 66
// module chunks = 0